import { render, staticRenderFns } from "./imprint.vue?vue&type=template&id=5ae36413&scoped=true&"
import script from "./imprint.vue?vue&type=script&lang=ts&"
export * from "./imprint.vue?vue&type=script&lang=ts&"
import style0 from "./imprint.vue?vue&type=style&index=0&id=5ae36413&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae36413",
  null
  
)

export default component.exports